var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopVendorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.8507 1.60117C28.1258 1.60117 29.1523 3.9028 29.1523 3.9028C29.1523 3.9028 28.1258 6.20443 26.8507 6.20443H15.0548C15.4478 6.33946 15.7913 6.64191 15.9659 7.01969L20.5692 16.2262C20.9368 17.01 20.4808 18.0663 19.6581 18.3361L16.877 19.2951V23.0352C16.8769 23.8386 16.1459 24.5696 15.3425 24.5696H13.8081C13.0047 24.5696 12.2738 23.8386 12.2737 23.0352V19.2951L9.49255 18.3361C8.66993 18.0663 8.21384 17.01 8.58149 16.2262L13.1848 7.01969C13.3876 6.59711 13.784 6.30663 14.2397 6.20443H2.29994C1.02484 6.20443 -0.00169086 3.9028 -0.00169086 3.9028C-0.00169086 3.9028 1.02484 1.60117 2.29994 1.60117H26.8507Z",
    fill: "#E4993D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8605 4.62204C15.3365 4.7141 15.76 5.04508 15.9633 5.48515L20.5666 14.6917C20.9343 15.4755 20.4782 16.5318 19.6556 16.8015L16.8744 17.7605V21.5007C16.8743 22.3041 16.1434 23.0351 15.34 23.0351H13.8056C13.0022 23.0351 12.2712 22.3041 12.2711 21.5007V17.7605L9.49 16.8015C8.66738 16.5318 8.21129 15.4755 8.57894 14.6917L13.1822 5.48515C13.4527 4.92171 14.0947 4.56051 14.7166 4.62204C14.7645 4.6205 14.8126 4.6205 14.8605 4.62204Z",
    fill: "#E4993D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5803 6.15723L19.1836 15.3638L15.3475 16.6583V21.5015H13.8131V16.6583L9.97706 15.3638L14.5803 6.15723Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1523 2.20853V2.47142C29.1523 3.69117 28.1219 4.67996 26.8507 4.67996L2.29999 4.67996C1.02884 4.67996 -0.00164223 3.69117 -0.00164223 2.47142V2.20853C-0.00164223 0.988781 1.02884 -9.53674e-06 2.29999 -9.53674e-06L26.8507 -9.53674e-06C28.1219 -9.53674e-06 29.1523 0.988781 29.1523 2.20853Z",
    fill: "#E4993D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6172 3.14615V1.61173L1.53205 1.61173V3.14615L27.6172 3.14615Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopVendorIcon);
export default __webpack_public_path__ + "static/media/topVendorIcon.5b616b999d91fa9c49480b24ceacb96f.svg";
export { ForwardRef as ReactComponent };